/**
 * Form success handlers for OctoberCMS AJAX forms.
 * Vanilla DOM — the theme no longer ships jQuery.
 */

function fadeOut(el, duration = 300) {
  if (!el) return Promise.resolve();
  return new Promise(resolve => {
    el.style.transition = `opacity ${duration}ms`;
    el.style.opacity = '0';
    setTimeout(() => {
      el.style.display = 'none';
      resolve();
    }, duration);
  });
}

function fadeIn(el, duration = 300) {
  if (!el) return Promise.resolve();
  return new Promise(resolve => {
    el.style.opacity = '0';
    el.style.display = '';
    requestAnimationFrame(() => {
      el.style.transition = `opacity ${duration}ms`;
      el.style.opacity = '1';
      setTimeout(resolve, duration);
    });
  });
}

export function initForms() {
  /**
   * Inline `data-request-success` handler for contact/vacancy/call-back forms.
   * Hides .contact__form and reveals .contact__success within the form's container.
   */
  window.onContactFormSuccess = function() {
    document.body.classList.remove('oc-loading');
    const indicator = document.querySelector('.stripe-loading-indicator');
    if (indicator) indicator.classList.add('loaded');

    document.querySelectorAll('.contact__form').forEach(el => fadeOut(el, 300));
    setTimeout(() => {
      document.querySelectorAll('.contact__success').forEach(el => fadeIn(el, 300));
    }, 400);
  };

  window.onFormSuccess = function(form, data, anchor, redirect) {
    if (redirect && redirect.length) {
      const newLocation = redirect.startsWith('http://') || redirect.startsWith('https://')
        ? redirect
        : window.location.origin + redirect;
      window.location.href = newLocation;
      return;
    }

    if (anchor) {
      history.replaceState(null, null, anchor);
    }

    // Use jQuery if available (loaded by OctoberCMS framework)
    const $ = window.jQuery || window.$;
    if ($) {
      $('body').removeClass('oc-loading');
      $('.stripe-loading-indicator').addClass('loaded');

      setTimeout(() => {
        const $outer = $(form).closest('.form__outer-container');
        const $container = $(form).closest('.form__container');
        const $success = $outer.find('.form__success');

        $outer.height($outer.height());
        $container.fadeOut();
        $outer.delay(100).animate({ height: $success.height() });
        $success.delay(400).fadeIn();
        $container.remove();
      }, 1000);
    } else {
      // Vanilla fallback
      document.body.classList.remove('oc-loading');
      const indicator = document.querySelector('.stripe-loading-indicator');
      if (indicator) indicator.classList.add('loaded');

      setTimeout(() => {
        const container = form.closest('.form__container');
        const outer = form.closest('.form__outer-container');
        const success = outer?.querySelector('.form__success');

        if (container) container.style.display = 'none';
        if (success) success.style.display = 'block';
      }, 1000);
    }

    window.dispatchEvent(new CustomEvent('onAfterFormSuccess', {
      bubbles: true,
      detail: { form, data, anchor, redirect },
    }));
  };
}
